import { defineComponent as _defineComponent } from 'vue'
import { useBasicStore } from '../../../stores/basic';
import { computed, ref } from 'vue';
import { storeToRefs } from 'pinia';
import Chat from '../Chat/index.vue';
import ManageMemberLeft from '../ManageMemberLeft/index.vue';
import { useRoomStore } from '../../../stores/room';


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const basicStore = useBasicStore();
const roomStore = useRoomStore();
const currentActive=ref('chat')
basicStore.setSidebarName('chat');
const { isSidebarOpen, sidebarName } = storeToRefs(basicStore);
const { userNumber } = storeToRefs(roomStore);
const title = computed((): string | undefined => {
  if (sidebarName.value === 'chat') {
    return '聊天';
  }
  if (sidebarName.value === 'manage-member') {
    return '成员';
  }
  return '';
});

function sidebarClick(more : any) {
  currentActive.value=more
  if (basicStore.setSidebarOpenStatus && basicStore.sidebarName === 'more') {
    basicStore.setSidebarOpenStatus(false);
    basicStore.setSidebarName('');
    return;
  }
  basicStore.setSidebarOpenStatus(true);
  basicStore.setSidebarName(more);
}

function handleClose(done: any) {
  basicStore.setSidebarOpenStatus(false);
  basicStore.setSidebarName('');
  done();
}

return { __sfc: true,basicStore, roomStore, currentActive, isSidebarOpen, sidebarName, userNumber, title, sidebarClick, handleClose, Chat, ManageMemberLeft }
}

})